// Oylik summa oldindan (Q-081): yangi restoran ustasi, tarif almashtirish va qurilmalar oynasida bir xil ko'rinish.
// Hisob packages/shared quoteMonthly() bilan — serverdagi app.billing_monthly qoidalari. Haqiqiy summani server hisoblaydi.
import { LIMIT_UNITS, addonLabel, addonPack, getModule, periodAmount } from '@onepos/shared';
import type { Quote } from '@onepos/shared';
import { useAsync } from '@onepos/ui';
import { api } from '../lib/api';
import { fmtMoney, monthsText } from '../lib/format';
import type { BillingSettings, Plan } from '../lib/types';

/** Tarif kartochkasi uchun: "kassa +39 000 so‘m · ofitsiant telefoni (5 talik) +129 000 so‘m · Maslahatchi +79 000 so‘m" */
export function addonPricesText(plan: Pick<Plan, 'addon_prices'>): string {
  const prices = plan.addon_prices ?? {};
  const parts: string[] = [];
  for (const k of Object.keys(LIMIT_UNITS)) {
    if (prices[k] === undefined) continue;
    const pack = addonPack(plan, k);
    parts.push(`${LIMIT_UNITS[k]}${pack > 1 ? ` (${pack} talik)` : ''} +${fmtMoney(prices[k])}`);
  }
  if (prices.branch !== undefined) parts.push(`filial +${fmtMoney(prices.branch)}`);
  for (const [k, v] of Object.entries(prices)) {
    if (k.startsWith('module.')) parts.push(`${getModule(k.slice(7))?.label ?? k.slice(7)} +${fmtMoney(v)}`);
  }
  return parts.join(' · ');
}

/** Chegirmalar (3, 6, 12 oy) — bir marta yuklanadi; bo'lmasa yillik qator ko'rsatilmaydi */
export function useDiscounts(): Record<string, number> | null {
  const s = useAsync(() => api.rpc<BillingSettings>('platform_billing_settings'), []);
  return s.data?.discounts ?? null;
}

export function MonthlyPreview({
  quote,
  planLabel,
  discounts,
  privileged,
  note,
}: {
  quote: Quote;
  planLabel: string;
  discounts?: Record<string, number> | null;
  privileged?: boolean;
  note?: string;
}) {
  if (quote.monthly === null) {
    return <p className="cn-muted">“{planLabel}” tarifining narxi belgilanmagan — summani Tariflar sahifasida narx kiritilgach ko‘rasiz.</p>;
  }
  const year = discounts ? periodAmount(quote.monthly, 12, discounts['12'] ?? 0) : null;
  return (
    <div className="cn-preview">
      <ul className="cn-list cn-list--kv">
        <li>
          <span className="cn-list__main">{planLabel} tarifi</span>
          <span className="op-num">{fmtMoney(quote.base)}</span>
        </li>
        {quote.items.map((a) => (
          <li key={a.key}>
            <span className="cn-list__main">
              + {addonLabel(a)}
              <span className="cn-list__sub">
                {a.key.startsWith('module.') ? 'tarifdan tashqari bo‘lim' : a.key === 'branch' ? 'qo‘shimcha filial' : 'tarifdan ortiq'} ·{' '}
                {a.price > 0 ? `${fmtMoney(a.price)} dan` : 'narx belgilanmagan — bepul'}
              </span>
            </span>
            <span className="op-num">{fmtMoney(a.total)}</span>
          </li>
        ))}
        <li>
          <strong>Oyiga</strong>
          <strong className="op-num">{fmtMoney(quote.monthly)}</strong>
        </li>
      </ul>
      {year !== null && (
        <p className="cn-muted cn-preview__year">
          {monthsText(12)} oldindan: <span className="op-num">{fmtMoney(year)}</span>
          {(discounts?.['12'] ?? 0) > 0 ? ` (−${discounts!['12']}%)` : ''}
        </p>
      )}
      {privileged && <p className="cn-muted">Imtiyozli restoran: qo‘shimchalar hisoblanmaydi.</p>}
      {note && <p className="cn-muted">{note}</p>}
    </div>
  );
}
